<template>
  <div class="bulk-section-wrapper">
    <div
      class="bulk-section"
      :class="$store.state.plan && $store.state.plan.type !== 'pro-yearly' &&
        $store.state.plan.group !== 'white-label' ? 'mt-10' : ''"
      id="bulk-pricing"
    >
      <ContactUsBulkModal
        v-if="!canUseNewEnterpriseInquiriesForm"
        :is-open-modal="isOpenModal"
        :total-billing-have-discount="totalBillingHaveDiscount"
        :quantity="quantity"
        :plan="plan"
        :fullSymbolCurrency="fullSymbolCurrency"
        :open-modal="isOpenModal"
        :total-billing="totalBilling"
        :discount-rate="discountRate"
        :plans="BulkLicensePlans"
        :formData="formData"
        @hide="isOpenModal = false"
        @showThanksModal="showThanksModal"
      />
      <EnterpriseInquiriesFormModal
        v-else
        :email="currentUser.email"
        :isOpenModal="isOpenModal"
        @hide="isOpenModal = false"
        @showThanksModal="showThanksModal"
      >
      </EnterpriseInquiriesFormModal>
      <ThanksYourRequestModal
        @closeThanksModal="isThanksRequestModal= false"
        v-if="isThanksRequestModal"
      />
      <div class="bulk-pricing-title">
        <h2 class="bulk-title ">
          {{ $i18nPresenter.t('Team Up and Save More') }}
        </h2>
        <div class="header-offer-badge">
          {{ $i18nPresenter.t('Offer Expires Soon!') }}
        </div>
      </div>

      <div class="text-center font-18 ">
        <div class="wrapper-bulk ">
          <span class="text-bulk-1">
            {{ $i18nPresenter.t('If you buy') }}
          </span>
          <aha-input
            class="font-14"
            @focus="trackingFocus('quantity')"
            @blur="resetError"
            placeholder="3"
            v-model="quantity"
            type="number"
            :min="2"
            @input="updateWhenChangeQuantity"
            :error="errorLimitQuantity"
          />
          <span class="wrapper-text-licences">
            {{ $i18nPresenter.t('licences of') }}
          </span>
          <div class="select-box">
            <span @click="trackingClickSelectBox">
              <aha-select
                :value="plan"
                @change="onChangeBulkLicensePlan"
              >
                <aha-select-option

                  v-for="(value, key) in BulkLicensePlans"
                  :key="key"
                  :value="key"
                  @click="trackingClickSelectBox()"
                >
                  {{ value }}
                </aha-select-option>
              </aha-select>
            </span>
            <span class="bulk-ml-2">
              {{ $i18nPresenter.t('plan, ') }}
            </span>
          </div>
          <div class="wrapper-text-pricing">
            <div class="wrapper-text " v-if="isEligibleToBuyMultipleLicenses">
              <span class="text-bill-annual">{{ $i18nPresenter.t('your annual bill will be') }}</span>
              <span class="bulk-license-total-value" :class="{'currency-grid-area': totalBillingHaveDiscount === 0}">
                <span class="font-bold ml-1" v-if="totalBillingHaveDiscount > 0">
                  {{ symbolCurrency }}{{ Math.round(totalBillingHaveDiscount * 100) / 100 | formatNumber }}
                </span>
              </span>

              <span class="pricing-label-discount bulk-ml-1" v-if="discountRate !==0 ">
                <p>{{ $i18nPresenter.t('save') }} {{ Math.round(discountRate * 100) }}%</p>
              </span>
              <del class="bulk-ml-1 total-billing" v-if="discountRate !== 0">
                {{ symbolCurrency }}{{ Math.round(totalBilling * 100) / 100 | formatNumber }}
              </del>
            </div>

            <div class="contact-us-text " v-else-if="isSelectWhiteLabelAndEnterprise">
              {{ $i18nPresenter.t('please contact us for pricing.') }}
            </div>
            <div class="wrapper-text" v-if="plan.length === 0">
              <span class="text-bill-annual">{{ $i18nPresenter.t('your annual bill will be') }}</span>
              <span class="font-bold bulk-ml-1 empty-text">
                {{ symbolCurrency }}---
              </span>
            </div>
          </div>
        </div>
        <div
          class="bulk-pricing-group"
          v-if="plan && quantity > 1"
        >
          <aha-antd-button
            v-if="isShowContactButton"
            v-aha-emit-action
            name="bulk-pricing-contact-us"
            :variant=" (!isEligibleToBuyMultipleLicenses) ? 'primary': 'secondary'"
            class="bulk-min-w-48"
            @click="openModal"
          >
            {{ $i18nPresenter.t('Contact us') }}
          </aha-antd-button>
          <aha-antd-button
            v-if="isEligibleToBuyMultipleLicenses"
            v-aha-emit-action
            name="bulk-pricing-buy-now"
            class="bulk-min-w-48"
            @click="createCheckout()"
            :submitting="isLoading"
            is-loading-inline
          >
            {{ $i18nPresenter.t('Buy now') }}
          </aha-antd-button>
        </div>
        <div class="error">
          <p>
            {{ createCheckoutSessionError }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Util from '@/util'
import ContactUsBulkModal from '@/components-v2/my-plan/user-pricing-v3/ContactUsBulkModal.vue'
import EnterpriseInquiriesFormModal from '@/components-v2/my-plan/user-pricing-v3/EnterpriseInquiriesFormModal.vue'
import ThanksYourRequestModal from '@/components-v2/my-plan/user-pricing-v3/ThanksYourRequestModal.vue'
import constants from '@/constant'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v3/PaymentLocalizationMixin'

export default {
  components: {
    ThanksYourRequestModal,
    ContactUsBulkModal,
    EnterpriseInquiriesFormModal,
  },
  mixins: [PaymentLocalizationMixin],
  data() {
    return {
      isThanksRequestModal: false,
      formData: {
        email: '',
        planName: '',
        message: '',
      },
      plan: 'pro-yearly', // 'essential-yearly', 'pro-yearly,
      isOpenModal: false,
      quantity: 3,
    }
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseNewEnterpriseInquiriesForm']),
    ...mapState({
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
      createCheckoutSessionError: (state) => state.createCheckoutSessionError,
      isCreatingCheckoutSession: (state) => state.isCreatingCheckoutSession,
      isCreatingCustomerPortal: (state) => state.isCreatingCustomerPortal,
    }),
    BulkLicensePlans() {
      return this.canUseNewEnterpriseInquiriesForm
        ? constants.BulkLicensePlansPricingV4
        : constants.BulkLicensePlansPricingV3
    },
    discountRate() {
      if (!this.plan || !this.quantity) {
        return 0
      }

      if (this.plan === 'essential-yearly') {
        if (this.quantity >= 2 && this.quantity <= 4) {
          return 0.25
        }
        if (this.quantity >= 5) {
          return 0.3
        }
        return 0
      }

      if (this.plan === 'pro-yearly') {
        if (this.quantity >= 2 && this.quantity <= 4) {
          return 0.3
        }
        if (this.quantity >= 5) {
          return 0.4
        }
      }

      if (this.plan === 'ultimate-daily') {
        return 0.08
      }
      return 0
    },
    errorLimitQuantity() {
      if (!this.quantity) {
        return false
      }
      return this.quantity < 2 || this.quantity > 200
    },

    isSelectWhiteLabelAndEnterprise() {
      return this.plan === 'enterprise' || this.plan === 'whitelabel'
    },

    hasNoTeam() {
      return this.currentUser.accountId == null
    },

    hasPaidTeamPlan() {
      return this.currentAccount.plan !== null && this.currentAccount.plan !== 'free'
    },

    isFreeTeam() {
      return this.currentAccount.plan == 'free' || this.currentAccount.plan == null
    },

    isEligibleToBuyMultipleLicenses() {
      return this.totalBilling > 0 &&
          !this.isSelectWhiteLabelAndEnterprise &&
          this.quantity > 1 &&
          this.plan
    },

    isPersonPlan() {
      return this.hasNoTeam &&
          this.plan.length > 0 &&
          this.currentUser.plan !== 'free'
    },
    isShowContactButton() {
      if (!this.isEligibleToBuyMultipleLicenses) {
        return true
      }

      if (this.quantity > 15 && this.quantity <= 200) {
        return true
      }

      if (this.quantity < 2 || this.quantity > 200) {
        return false
      }
      if (this.totalBilling === 0) {
        return false
      }

      return false
    },

    totalBillingHaveDiscount() {
      const total = this.computeTheTotalValue(this.plan, this.quantity)
      return total * (1 - this.discountRate)
    },

    totalBilling() {
      const total = this.computeTheTotalValue(this.plan, this.quantity)
      if (total === 0) {
        return 0
      }
      return total
    },
    isLoading() {
      if (this.currentUser.plan === 'free') {
        return this.isCreatingCheckoutSession
      }
      return this.isCreatingCustomerPortal
    },

  },

  mounted() {
    this.addTestDailyPlanForBulkLicense()
  },

  methods: {
    ...mapActions(['createCheckoutSessionAction', 'hookBulkPricingAction', 'createCustomerPortalUpgradeFlowAction']),
    showThanksModal() {
      this.isThanksRequestModal = true
      this.isOpenModal = false
      this.formData.message = ''
    },
    async createCheckout() {
      if (this.quantity < 2) {
        this.$store.commit('createCheckoutSessionErrorMutation', 'Quantity must be greater than 1')
        return
      }

      if (this.quantity > 200) {
        this.$store.commit('createCheckoutSessionErrorMutation', 'Quantity must not exceed 200')
        return
      }

      const payload = {
        plan: this.plan,
        quantity: this.quantity,
        cancelUrl: window.location.origin + window.location.pathname,
      }
      Util.mixpanelTracking('My Plan', 'BLP > Buy now', this.plan, {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      })
      if (this.currentUser.plan === 'free') {
        await this.createCheckoutSessionAction(payload)
      } else {
        await this.createCustomerPortalUpgradeFlowAction(payload)
      }
    },
    onChangeBulkLicensePlan(plan) {
      this.plan = plan
      this.trackingSelectBox()
    },
    trackingSelectBox() {
      if (this.plan.length > 0 && this.quantity > 1) {
        Util.mixpanelTracking('My Plan', 'BLP > Calculated', this.plan, null, {
          quantity: this.quantity,
          amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
        })
      }
      Util.mixpanelTracking('My Plan', 'BLP > Pick a plan from the list', this.plan)
    },
    trackingClickSelectBox() {
      Util.mixpanelTracking('My Plan', 'BLP > Select plan > Open drop-down menu')
    },
    trackingFocus(type) {
      const eventCustoms = {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      }
      if (type === 'email') {
        Util.mixpanelTracking('My Plan',
          'BLP > Request a quote > Email > Focus input', this.plan, null,
          eventCustoms)
        return
      }
      if (type === 'requirement') {
        Util.mixpanelTracking('My Plan',
          'BLP > Request a quote > Message > Focus input', null,
          this.plan,
          eventCustoms)
        return
      }
      if (type === 'quantity') {
        Util.mixpanelTracking('My Plan',
          'BLP > Quantity > Focus input', null,
          this.plan,
          eventCustoms)
      }
    },
    updateWhenChangeQuantity() {
      if (this.quantity > 200) {
        this.quantity = 200
      }
    },

    closeModalThanksRequest() {
      this.isThanksRequestModal = false
    },
    closeRequestModal() {
      this.isOpenModal = false
      this.formData.message = ''
      Util.mixpanelTracking('My Plan', 'BLP > Request a quote > Close pop-up', this.plan, null, {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      })
    },
    openModal() {
      this.formData.email = this.currentUser.email
      this.isOpenModal = true
      Util.mixpanelTracking('My Plan', 'BLP > Contact us', this.plan, null, {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      })
    },

    computeTheTotalValue(plan, quantity) {
      if (plan === '' || this.isSelectWhiteLabelAndEnterprise) {
        return 0
      }

      if (!quantity) {
        return 0
      }
      if (!this.fullSymbolCurrency) {
        return 0
      }

      return constants.pricesMap[this.fullSymbolCurrency.toLowerCase()][plan] * quantity
    },

    addTestDailyPlanForBulkLicense() {
      if (sessionStorage.getItem('test-bulk-license-daily') == 'true') {
        this.BulkLicensePlans['ultimate-daily'] = 'Ultimate Daily'
      }
    },

    resetError() {
      this.$store.commit('createCheckoutSessionErrorMutation', '')
    },

  },
}
</script>
<style lang="scss" scoped>
</style>
